import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

// Per-card % widths — relative to card/container width — no static pixel values
const SK_ROLE_CARDS: { name: string; desc: string; chips: string[] }[] = [
    { name: '45%', desc: '80%', chips: ['28%', '36%', '24%', '32%'] },
    { name: '60%', desc: '65%', chips: ['32%', '22%', '38%']        },
    { name: '38%', desc: '78%', chips: ['25%', '33%', '22%', '30%'] },
    { name: '52%', desc: '70%', chips: ['36%', '28%', '32%']        },
];

const RolesSkeleton: React.FC<{
    count?: number;
}> = ({ count = 4 }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 animate-fade-in-up">
        {Array.from({ length: count }).map((_, i) => {
            const sk = SK_ROLE_CARDS[i % SK_ROLE_CARDS.length];
            return (
                <div
                    key={i}
                    className="group relative flex flex-col rounded-2xl border bg-[var(--v2-bg-card)] overflow-hidden"
                    style={{ borderColor: 'var(--v2-border-card)' }}
                >
                    {/* ── Top accent bar — genuinely full-width ── */}
                    <ShimmerBox className="h-1.5 w-full flex-shrink-0 rounded-none" delay={`${i * 0.06}s`} />

                    <div className="flex flex-col gap-4 p-5 flex-1">

                        {/* ── Header: shield icon (fixed) + name/desc (relative %) + 2 action btns (fixed) ── */}
                        <div className="flex items-start gap-3">
                            {/* Shield icon box — always w-10 h-10 */}
                            <ShimmerBox className="w-10 h-10 rounded-xl flex-shrink-0" delay={`${i * 0.06 + 0.04}s`} />
                            <div className="flex-1 min-w-0 space-y-2 pt-0.5">
                                <ShimmerBox className="h-4 rounded" style={{ width: sk.name }} delay={`${i * 0.06 + 0.06}s`} />
                                <ShimmerBox className="h-3 rounded" style={{ width: sk.desc }} delay={`${i * 0.06 + 0.08}s`} />
                            </div>
                            {/* Edit + Delete btns — always w-8 h-8 */}
                            <div className="flex items-center gap-1 flex-shrink-0">
                                <ShimmerBox className="w-8 h-8 rounded-lg" delay={`${i * 0.06 + 0.10}s`} />
                                <ShimmerBox className="w-8 h-8 rounded-lg" delay={`${i * 0.06 + 0.12}s`} />
                            </div>
                        </div>

                        {/* ── PERMISSIONS label (fixed short) + count (fixed short) + progress bar (genuinely full-width) ── */}
                        <div className="flex flex-col gap-1.5">
                            <div className="flex items-center justify-between">
                                <ShimmerBox className="h-2.5 rounded" style={{ width: '32%' }} delay={`${i * 0.06 + 0.14}s`} />
                                <ShimmerBox className="h-3 rounded"   style={{ width: '8%'  }} delay={`${i * 0.06 + 0.16}s`} />
                            </div>
                            {/* Progress bar track — full width is correct here */}
                            <ShimmerBox className="h-1.5 w-full rounded-full" delay={`${i * 0.06 + 0.18}s`} />
                        </div>

                        {/* ── ACCESS TO label (fixed short) + chip row (relative %) ── */}
                        <div className="flex flex-col gap-1.5">
                            <ShimmerBox className="h-2.5 rounded" style={{ width: '20%' }} delay={`${i * 0.06 + 0.20}s`} />
                            <div className="flex flex-wrap gap-1.5">
                                {sk.chips.map((w, j) => (
                                    <ShimmerBox
                                        key={j}
                                        className="h-6 rounded-lg"
                                        style={{ width: w }}
                                        delay={`${i * 0.06 + j * 0.04 + 0.22}s`}
                                    />
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            );
        })}
    </div>
);

export default RolesSkeleton;
